<template>
  <router-view></router-view>
</template>

<style lang="scss">
// 3rd party plugins css
@import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~perfect-scrollbar/css/perfect-scrollbar.css';
@import '~socicon/css/socicon.css';
@import 'assets/plugins/keenthemes-icons/font/ki.css';

// Main demo style scss
@import 'assets/sass/style.vue';

// Verbindliche Design-Tokens als CSS Custom Properties
@import 'assets/sass/components/design-tokens';

// Pill-Badges (Status, Priorität, Fälligkeitsdatum)
@import 'assets/sass/components/pill-badge-styles';

// Kachel-Badges im Stil der Flugverfügbarkeit-/Zimmerkontingente-Widgets
@import 'assets/sass/components/kachel-badge-styles';

// Auswahl-Chips im weißen Ghost-Stil (Filter, Wochentage, Teilbeträge)
@import 'assets/sass/components/chip-styles';

// Grundgerüst aller Modals: Rahmen, Radius, Paddings, Footer, Titel, Schließen
@import 'assets/sass/components/modal-base-styles';

// Formularfelder innerhalb eines Modals
@import 'assets/sass/components/modal-form-styles';

// Gemeinsame Dialog-/Modal-Button-Styles (Primär/Sekundär)
@import 'assets/sass/components/dialog-button-styles';

// Hinweis-Banner der Restriktionen (Info, Warnung, Restriktion des Landes)
@import 'assets/sass/components/restriktionen-hinweis-styles';

// Optik der Aktionen-Dropdowns, opt-in über menu-class="aktionen-dropdown"
@import 'assets/sass/components/aktionen-dropdown-styles';

.icon-sm {
  font-size: 0.75rem;
}
</style>

<script>
import { OVERRIDE_LAYOUT_CONFIG } from '@/core/common/stores/config.module';
import { DISPLAYED_ERROR_MSG } from '@/core/common/stores/error-handler.module.js';
import { mapState } from 'vuex';

export default {
  name: 'MetronicVue',
  mounted() {
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/common/layout.config.json)
     */
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
  },
  watch: {
    errorModalMsg() {
      this.$bvModal.msgBoxOk(this.errorModalMsg, {
        title: 'Error',
        variant: this.errorType,
        size: 'lg',
        buttonSize: 'sm',
        centered: true,
      });
      this.$store.dispatch(DISPLAYED_ERROR_MSG);
    },
    errorNotificationMsg() {
      this.$bvToast.toast(this.errorNotificationMsg, {
        title: 'Error',
        variant: this.errorType,
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
      });
      this.$store.dispatch(DISPLAYED_ERROR_MSG);
    },
  },
  computed: {
    ...mapState({
      errorModalMsg: state => state.errorHandler.errorModalMsg,
      errorNotificationMsg: state => state.errorHandler.errorNotificationMsg,
      errorType: state => state.errorHandler.errorType,
    }),
  },
};
</script>
